export const CURRENCY = {
  VND: 'VND',
  USD: 'USD',
  EUR: 'EUR',
}

export const UNIT_MULTIPLIER = {
  1: 1,
  HUNDRED: 1e-2,
  THOUSAND: 1e-3,
  MILLION: 1e-6,
  BILLION: 1e-9,
  TRILLION: 1e-12,
}

export const UNIT = {
  SINGLE: {
    unitKey: 'SINGLE',
    multiplier: 1,
    name: 'currencyUnit.SINGLE',
    label: 'currencyUnit.SINGLE_LABEL',
  },
  HUNDRED: {
    unitKey: 'HUNDRED',
    multiplier: 1e-2,
    name: 'currencyUnit.HUNDRED',
    label: 'currencyUnit.HUNDRED_LABEL',
  },
  THOUSAND: {
    unitKey: 'THOUSAND',
    multiplier: 1e-3,
    name: 'currencyUnit.THOUSAND',
    label: 'currencyUnit.THOUSAND_LABEL',
  },
  MILLION: {
    unitKey: 'MILLION',
    multiplier: 1e-6,
    name: 'currencyUnit.MILLION',
    label: 'currencyUnit.MILLION_LABEL',
  },
  BILLION: {
    unitKey: 'BILLION',
    multiplier: 1e-9,
    name: 'currencyUnit.BILLION',
    label: 'currencyUnit.BILLION_LABEL',
  },
  TRILLION: {
    unitKey: 'TRILLION',
    multiplier: 1e-12,
    name: 'currencyUnit.TRILLION',
    label: 'currencyUnit.TRILLION_LABEL',
  },
}

export const CURRENCY_UNIT = {
  VND: [
    UNIT.SINGLE.unitKey,
    UNIT.MILLION.unitKey,
    UNIT.BILLION.unitKey,
    UNIT.TRILLION.unitKey,
  ],
  USD: Object.keys(UNIT).slice(0, -1),
  EUR: Object.keys(UNIT).slice(0, -1),
}
